import { Route, Switch } from "react-router-dom";
import { PATH_TRANSFER, PATH_TRANSFER_ADD_BANK_ACCOUNT } from "./paths";
import { RouteAddBankAccount } from "./routes/RouteAddBankAccount";
import { RouteIndex } from "./routes/RouteIndex";

export const Transfer = () => {
  return (
    <Switch>
      <Route
        path={PATH_TRANSFER_ADD_BANK_ACCOUNT}
        component={RouteAddBankAccount}
      />

      <Route path={PATH_TRANSFER} component={RouteIndex} />
    </Switch>
  );
};
